import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCameraOutline = function SvgCameraOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5704 4.5C10.1524 4.5 9.76214 4.70888 9.53031 5.05662L8.71777 6.27542C8.20774 7.04047 7.3491 7.5 6.42963 7.5H4.75C4.05964 7.5 3.5 8.05964 3.5 8.75V18.25C3.5 18.9404 4.05964 19.5 4.75 19.5H19.25C19.9404 19.5 20.5 18.9404 20.5 18.25V8.75C20.5 8.05964 19.9404 7.5 19.25 7.5H17.5704C16.651 7.5 15.7923 7.04051 15.2823 6.27545C15.2823 6.27543 15.2823 6.27546 15.2823 6.27545L14.4697 5.05665C14.2379 4.70894 13.8476 4.5 13.4296 4.5H10.5704ZM8.28223 4.22458C8.79226 3.45952 9.6509 3 10.5704 3H13.4296C14.349 3 15.2077 3.45949 15.7177 4.22455C15.7177 4.22454 15.7177 4.22457 15.7177 4.22455L16.5303 5.44335C16.7621 5.79106 17.1524 6 17.5704 6H19.25C20.7688 6 22 7.23122 22 8.75V18.25C22 19.7688 20.7688 21 19.25 21H4.75C3.23122 21 2 19.7688 2 18.25V8.75C2 7.23122 3.23122 6 4.75 6H6.42963C6.84758 6 7.23786 5.79112 7.46969 5.44338L8.28223 4.22458Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5C10.6193 10.5 9.5 11.6193 9.5 13C9.5 14.3807 10.6193 15.5 12 15.5C13.3807 15.5 14.5 14.3807 14.5 13C14.5 11.6193 13.3807 10.5 12 10.5ZM8 13C8 10.7909 9.79089 9 12 9C14.2091 9 16 10.7909 16 13C16 15.2091 14.2091 17 12 17C9.79089 17 8 15.2091 8 13Z"
  })));
};

export { SvgCameraOutline as ReactComponent };
//# sourceMappingURL=camera-outline.svg.js.map
